<template>
  <v-card>
    <v-toolbar :color="$store.getters.toolbarColor" dark>
      <v-toolbar-title>
        <template v-if="$mode === 'uoi'">
          <v-avatar :tile="true" :size="28">
            <img src="/static/img/uoi-gate.svg" alt="logo">
          </v-avatar>
        </template>
        {{mainTitle}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-menu bottom left>
        <v-btn icon slot="activator" dark>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="item in loginMenu" :key="item.title" @click="handleMenu(item.action)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> -->
    </v-toolbar>
    <v-card-text>
      <message :messages="messages"></message>
      <form>
        <v-text-field v-model="loginForm.email" :label="labels.email" type="email" :error-messages="errors.collect('email')" v-validate="'required|email'" data-vv-name="email" :data-vv-as="labels.email"></v-text-field>
        <v-text-field v-model="loginForm.password2" :label="labels.password" :type="pwdType" @focus="pwdType='password'" @blur="doPassValue"
        :error-messages="errors.collect('password2')" v-validate="'required'" data-vv-name="password2" :data-vv-as="labels.password"></v-text-field>
        <v-text-field v-model="loginForm.password" type="hidden" v-show="false" readonly></v-text-field>
        <v-text-field v-model="loginForm.password3" type="password" v-show="false" readonly></v-text-field>
        <v-checkbox v-model="loginForm.rememberMe" :label="labels.rememberMe" :error-messages="errors.collect('rememberMe')" data-vv-name="rememberMe" type="checkbox" :data-vv-as="labels.rememberMe"></v-checkbox>
        <v-btn color="primary" type="submit" @click.prevent="doLogin" :loading="loading">Login</v-btn>
        <v-btn flat :to="{ name: 'forgetPassword'}">Forget password?</v-btn>
      </form>
      <div class="pt-3" v-if="$mode === 'dev'">
        <v-alert color="grey lighten-3" icon="mdi-alert" :value="true">
          <span class="disclaimerText">
            This product is currently under development. For a demo, please contact us at
            <a href="mailto:enquiries@pst.sg">enquiries@pst.sg</a>
          </span>
        </v-alert>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { setCookie, getCookie } from '@/utils/cookie'
import AES from 'crypto-js/aes'
import { mavKey } from '@/const'
import Enc from 'crypto-js/enc-utf8'

export default {
  data() {
    return {
      labels: {
        email: 'Email*',
        password: 'Password*',
        rememberMe: 'Remember me?'
      },
      loginForm: {
        email: '',
        password: '',
        password2: '',
        password3: '',
        rememberMe: false
      },
      loginMenu: [
        {
          title: 'Submit Help Ticket',
          action: 'submitHelp'
        }
      ],
      loading: false,
      pwdType: 'search'
    }
  },
  computed: {
    mainTitle() {
      return this.$store.state.app.projectTitleLong
    }
  },
  methods: {
    handleMenu(name) {
      switch (name) {
        case 'submitHelp': this.submitHelp()
          break
      }
    },
    submitHelp() {
      this.$snotify.warning('Features not ready')
    },
    doPassValue() {
      // AR: 21-Nov Added to avoid auto-save password
      if (this.loginForm.password2.trim() !== '') {
        this.loginForm.password = this.loginForm.password2
      }
    },
    doLogin() {
      // AR: 21-Nov Added to avoid auto-save password
      if (this.loginForm.password2.trim() !== '') {
        this.loginForm.password = this.loginForm.password2
        this.loginForm.password3 = this.loginForm.password2.replace(/./g, '*')
        this.loginForm.password2 = this.loginForm.password3
      }
      if (this.loginForm.password2 === this.loginForm.password3) {
        this.resetMessages()
        this.$validator.validateAll().then(result => {
          if (result) {
            const apiURI = this.$store.state.app.baseMenu.login
            if (apiURI) {
              this.loading = true
              this.$http.post(apiURI, this.loginForm)
                .then((response) => {
                  // Process Login Form
                  this.$store.dispatch('processLoginForm', response)
                    .then(() => {
                      // Redirect to dashboard
                      // this.notify(data)
                      this.loading = false
                      this.$router.push({ name: 'dashboard' })

                      // Successful check rembme to setcookie
                      if (this.loginForm.rememberMe) {
                        // AR: SCR 5.5 Sensitive Data Exposure (information in cookie) 03Dec20
                        setCookie('username', AES.encrypt(this.loginForm.email, mavKey).toString(), 30)
                        // setCookie('username', this.loginForm.email, 30)
                      } else {
                        setCookie('username', '')
                      }
                    })
                })
                .catch((error) => {
                  const { data } = error.response
                  if (data) {
                    this.message(data)
                    this.fieldMessage(data)
                  }
                  this.loading = false
                })
            } else {
              this.errorMessage('Error encountered')
            }
          } else {
            this.promptFieldCheck()
          }
        })
      }
    }
  },
  created() {
    if (getCookie('username')) {
      // AR: SCR 5.5 Sensitive Data Exposure (information in cookie) 03Dec20
      var bytes = AES.decrypt(getCookie('username'), mavKey)
      this.loginForm.email = bytes.toString(Enc)
      this.loginForm.rememberMe = true
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
.disclaimerText {
  color: #666;
}
</style>
